import { _,Backbone,Obscura,Radio } from '../../vendor';
import { Dependencies } from '../utils';

import InboomaBaseAsyncCollection from './InboomaBaseAsyncCollection';
import Price from '../models/Price';

export default InboomaBaseAsyncCollection.extend({
  
    collectionName : 'prices',
    model : Price,
    url : '/prices',

});